// Vendors
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { useUploadIdContextConsumerHook } from 'containers/upload-id/contexts/upload-id.context';
// Event Handlers
import { UploadIdLandingHandlers } from '../handlers/upload-id-landing.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { useAppContextConsumerHook } from 'contexts/app.context';
import { UploadIdTrackingHandlers } from '../handlers/upload-id-landing.tracking.handlers';
import { UploadIdLandingHookType } from './types/upload-id-landing.hook.type';

const useUploadIdLandingHook = (): UploadIdLandingHookType => {
  const { formatMessage } = useIntl();

  const { setCurrentState } = useAppContextConsumerHook(),
    { setUploadIdState, setVerificationInformation } = useUploadIdContextConsumerHook(),
    { flowApiData, setMainButtonConfiguration, setCompactView } = useLayoutContextConsumerHook(),
    { documentType } = flowApiData;

  const { showBoundary: setError } = useErrorBoundary();

  const { handleContinueButtonClickTracking, handlePageDisplayedTracking } =
    useAppTrackingHook(UploadIdTrackingHandlers);

  const {
    handleSetupUploadIdLandingButtonConfiguration,
    handleEnableCompactView,
    handleResponsive,
  } = UploadIdLandingHandlers({
    formatMessage,
    handleContinueButtonClickTracking,
    setCompactView,
    setCurrentState,
    setError,
    setMainButtonConfiguration,
    setUploadIdState,
    setVerificationInformation,
  });

  useEffect(() => {
    handleSetupUploadIdLandingButtonConfiguration();
    handlePageDisplayedTracking();
    handleEnableCompactView();
    addEventListener('resize', handleResponsive);
    return () => {
      removeEventListener('resize', handleResponsive);
    };
  }, []);

  return {
    documentType,
  };
};

export { useUploadIdLandingHook };
